export default __webpack_public_path__ + "static/Diana Rotondo-2fdc0301d9f51f14a4a0df20308e4f7f.jpg";